import React, { useEffect, useMemo, useRef } from 'react';
import { Input } from 'shared-components/Input';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import { generateSearchStyles } from 'components/Search/SearchStyles';
import { useTheme } from '@emotion/react';
import { Box } from '@mui/material';

interface SearchProps {
    searchInput: string;
    setSearchInput: (value: string | null) => void;
}

export const MIN_SEARCH_LENGTH = 3;

const Search = ({ searchInput = '', setSearchInput }: SearchProps) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const theme = useTheme();
    const styles = useMemo(() => generateSearchStyles(theme), [theme]);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    const showHint = searchInput && searchInput.length >= 1;
    const isHintShort = searchInput && searchInput.length < MIN_SEARCH_LENGTH;

    return (
        <>
            <Box sx={styles.wrapper}>
                <Input
                    id="searchInput"
                    placeholder="Search"
                    className="searchInput"
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                    ref={inputRef}
                />
                <Box className="icon">
                    <SearchIcon fontSize="small" />
                </Box>
                { searchInput.length > 0 && (
                    <Box className="clearIcon" onClick={() => setSearchInput('')}>
                        <ClearIcon fontSize="small" />
                    </Box>
                )}
            </Box>
            <Box
                sx={styles.hint} style={{
                    opacity: showHint ? 1 : 0,
                    pointerEvents: 'none',
                    transition: 'opacity 0.2s ease-in-out',
                }}
            >
                {isHintShort ? `Please enter at least ${
                    MIN_SEARCH_LENGTH
                } characters` : 'Some results are filtered out, clear search to see all results'}
            </Box>
        </>
    );
};

export default Search;
